import { getPlatformTypeLabel } from '@boViews/helpers';
import Tag from '@sharedComponents/Tag';
import { useTranslation } from 'react-i18next';

// Demo platforms follow the client brand (primary) on purpose; every other type uses a frozen colour.
const TYPE_COLORS = {
    PRODUCTION: 'error',
    RECETTE: 'warning',
    DEMO: 'primary',
    DEMO_ATS: 'primary',
    PREPRODUCTION: 'disabled',
    SALON: 'teal',
};

const PlatformTypeBadge = ({ type }) => {
    const { t } = useTranslation('bo');
    return (
        <Tag color={TYPE_COLORS[type] ?? 'neutral'} size="badge" fontSize="xs" noTruncate>
            {getPlatformTypeLabel(t, type)}
        </Tag>
    );
};

export default PlatformTypeBadge;
